import { GameType } from '../../../models/communication/app-enums.model';
import { OpenGameFlow } from '../../game-flows/open.game.flow';
import { DragonTigerGame } from '../dragon-tiger/dragon-tiger.game';

export class OpenDragonTigerGame extends DragonTigerGame {
    override gameType = GameType.OpenDragonTiger;
    override flow: OpenGameFlow = new OpenGameFlow(this);
}
